module.exports = function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }

 if (data.state.savedFilter) { ;
__p += '\n<div class="saved-filter-name">' +
__e( data.state.savedFilter.name ) +
'</div>\n';
 } ;
__p += '\n<div class="tokens has-saved-filter-' +
((__t = ( !!data.state.savedFilter )) == null ? '' : __t) +
'"></div>\n<div class="text has-saved-filter-' +
((__t = ( !!data.state.savedFilter )) == null ? '' : __t) +
'"></div>\n<div class="controls"></div>\n<div class="filters-menu hidden"></div>\n<div class="typeahead"></div>';
return __p
}